// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__m6qmV","select":"styles_select__sgh3Q"};